import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import NewTabLink from "components/links/NewTabLink";
import ILogoLink from "./ILogoLink";
import clsx from "clsx";
import { footerItemHoverOpacity } from "theme";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:hover": {
                opacity: footerItemHoverOpacity,
            },
        },
    })
);

interface IProps {
    logoLink: ILogoLink;
    key?: any;
    className?: string;
}

export default function LogoLink(props: IProps) {
    const classes = useStyles();
    const { logoLink, className, key } = props;

    return (
        <NewTabLink
            key={key}
            href={logoLink.link}
            className={clsx(className, classes.root, logoLink.className)}
        >
            {logoLink.logo}
        </NewTabLink>
    );
}
